var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [_c("header-item"), _vm._v(" "), _c("list-item"), _vm._v(" "), _c("gotop")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }